import React from 'react';

import { CaseReport } from '../../models/CaseTypes';
import Recording from '../../components/CaseViewer/Recording';

interface CaseRecordingSectionProps {
  caseReport: CaseReport;
}

export function CaseRecordingSection({ caseReport }: CaseRecordingSectionProps): React.JSX.Element {
  return (
    <Recording caseReport={caseReport} />
  );
}
